// Mirrors services/parser-worker/config.json's `disciplines` and `special_types`
// keys. Keep in sync — the parser writes these strings into
// submission_pages.category, and the review UI compares against them.
//
// Display labels are humanized; the underlying value persisted to
// submission_pages.review_human_category is the snake_case key on the right.

export interface KnownCategory {
  readonly value: string;
  readonly label: string;
  readonly group: 'discipline' | 'special';
}

export const KNOWN_CATEGORIES: readonly KnownCategory[] = [
  { value: 'structural', label: 'Structural', group: 'discipline' },
  { value: 'architectural', label: 'Architectural', group: 'discipline' },
  { value: 'civil', label: 'Civil', group: 'discipline' },
  { value: 'mechanical', label: 'Mechanical', group: 'discipline' },
  { value: 'electrical', label: 'Electrical', group: 'discipline' },
  { value: 'plumbing', label: 'Plumbing', group: 'discipline' },
  { value: 'fire_protection', label: 'Fire protection', group: 'discipline' },
  { value: 'landscape', label: 'Landscape', group: 'discipline' },
  { value: 'telecommunications', label: 'Telecommunications', group: 'discipline' },
  { value: 'cover_sheet', label: 'Cover sheet', group: 'special' },
  { value: 'drawing_index', label: 'Drawing index', group: 'special' },
  { value: 'general_notes', label: 'General notes', group: 'special' },
  { value: 'specifications', label: 'Specifications', group: 'special' },
  { value: 'geotechnical', label: 'Geotechnical', group: 'special' },
  { value: 'survey', label: 'Survey', group: 'special' },
  { value: 'addendum', label: 'Addendum', group: 'special' },
  { value: 'structural_schedule', label: 'Structural schedule', group: 'special' },
];

export const KNOWN_CATEGORY_VALUES: readonly string[] =
  KNOWN_CATEGORIES.map((c) => c.value);

export function isKnownCategory(value: string): boolean {
  return KNOWN_CATEGORY_VALUES.includes(value);
}
